<template>
    <div>
        <f-title
            v-if  = "isLim && showTitle"
            :title = "$t('contract.billing')"
            class = "mt-10"
        />

        <c-column-header
            v-if   = "isLim && !showTitle"
            class  = "primary mt-1"
            :label = "$t('contract.billing')"
        />

        <div :class="border"  v-if="isLim">
            <v-row class="no-frame"  >
                <v-col class="no-frame">
                    <f-enum-select
                        v-model      = "contract.invoiceHandling"
                        :readonly    = "readonly"
                        label        = "Gruppierung"
                        module       = "msd"
                        type         = "limInvoiceHandling"
                        :rules    = "[ requiredRule ]"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame">
                    <f-enum-select
                        v-model    = "contract.tier"
                        :readonly  = "readonly"
                        :label     = "$t('contract.lim.tier')"
                        module     = "msd"
                        type       = "contractLimTier"
                        :clearable = "true"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame pr-2">
                    <v-text-field
                        type      = "number"
                        :label    = "$t('contract.lim.splitMaintenance')"
                        :readonly = "readonly"
                        v-model   = "contract.splitMaintenance"
                        :rules    = "percentRule"
                        @input    ="onChangeSplitMaintenance"
                    />
                </v-col>
                <v-col class="no-frame p-2">
                    <v-text-field
                        type      = "number"
                        :label    = "$t('contract.lim.splitRepair')"
                        :readonly = "readonly"
                        v-model   = "contract.splitRepair"
                        :rules    = "percentRule"
                        @input    = "onChangeSplitRepair"
                    />
                </v-col>
            </v-row>
        </div>


        <f-title
            v-if   = "showTitle"
            class  = "mt-5"
            :title = "$t('contract.addresses')"
        />

        <c-column-header
            v-if   = "!showTitle"
            class  = "primary mt-2"
            :label = "$t('contract.addresses')"
        />

        <div
            :class="border"
        >
            <v-row class="no-frame mb-5">
                <s-contract-lim-recipients
                    v-model   = "contract.benefitRecipient"
                    :label    = "$t('contract.recipient.benefit')"
                    :customer = "contract.customer.id"
                    :readonly = "readonly"
                    :rules    = "[ requiredRule ]"
                    type      = "benefit"
                />
            </v-row>

            <v-row class="no-frame" >
                <s-contract-lim-recipients
                    v-model   = "contract.invoiceRecipient"
                    :label    = "$t('contract.recipient.invoice')"
                    :customer = "contract.customer.id"
                    :readonly = "readonly"
                    :rules    = "[ requiredRule ]"
                    type      = "invoice"
                />
            </v-row>
        </div>

    </div>
</template>

<script>

import Core   from "@/modules/core/service/Core";
import FTitle from "@/modules/core/components/utils/FTitle";
import SContractLimRecipients from "@/modules/msd/company/contract/components/controls/lim/SContractLimRecipients";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import Contract from "@/modules/msd/company/contract/service/Contract";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";

export default {
    name: "CContractLimTerms",
    components: {
        CColumnHeader,
        FEnumSelect,
        SContractLimRecipients,
        FTitle
    },

    props: {
        contract: {
            required: false,
            type: Object,
            default: function () {
                return {
                    grossamount: null,
                    netamount  : null
                }
            }
        },

        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        height: {
            required: false,
            type    : Number,
            default : function () {
                return 162;
            }
        },

        form () {

        }
    },


    data: () => ({
        readonly: false,
        type: 1,

        percentRule: [
            (v)=> {
                if (v && (v <= 0 || v > 100)) {
                    return 'Zahl zwischen 1 und 100'
                }

                return true;
            }
        ]
    }),

    computed: {
        isLim () {
            if (!this.contract.type) {
                return false;
            }
            return this.contract.type.id === Contract.enums.types.lim;
        },

        requiredRule() {
            return Core.rule.required;
        },

        border () {
            if (this.showTitle) {
                return null;
            }

            return "lm-border pa-3 pt-2 mt-1";
        },

        netamount () {
            return this.contract.netamount;
        },

        grossamount () {
            return this.contract.grossamount;
        }
    },

    watch: {
        type () {
        },

        netamount () {
            this.$nextTick(() => this.validate ())
        },

        grossamount () {
            this.$nextTick(() => this.validate ())
        }
    },

    methods: {
        onChangeSplitMaintenance () {
            const value =this.contract.splitMaintenance;
            if (!value && value.length === 0) {
                this.contract.splitRepair = null;
                return;
            }

            const intValue = parseInt(value);
            if (intValue <= 0 || intValue > 100) {
                this.contract.splitRepair = null;
                return;
            }

            this.contract.splitRepair = 100 - this.contract.splitMaintenance;
        },

        onChangeSplitRepair () {
            const value =this.contract.splitRepair;
            if (!value && value.length === 0) {
                this.contract.splitMaintenance = null;
                return;
            }

            const intValue = parseInt(value);
            if (intValue <= 0 || intValue > 100) {
                this.contract.splitMaintenance = null;
                return;
            }

            this.contract.splitMaintenance = 100 - this.contract.splitRepair;
        },

        netAmountGrossamountValidation () {
            if (this.contract.netamount >  this.contract.grossamount) {
                return "EK muss kleiner gleich VK sein"
            }

            return true;
        },

        validate () {
            const form = this.$refs.netamount.$refs.input.form;
            form.validate ();
        }
    }
}

</script>

<style scoped>

</style>